module.exports = __webpack_public_path__ + "static/media/TN-Women-Outerwears-2.0_OptionAll.2feedb81.svg";